import { AssetConfig } from '@/config/assets-config'
import logoMobile from '@/features/assets/vanilla/logo_mobile.svg'
import logoDesktop from '@/features/assets/vanilla/logo_desktop.svg'
import competition from '@/features/assets/vanilla/store/competition.png?w=55;110;165&as=srcset&imagetools'
import postal from '@/features/assets/vanilla/store/postal.png?w=55;110;165&as=srcset&imagetools'
import social from '@/features/assets/vanilla/store/social.png?w=55;110;165&as=srcset&imagetools'
import specialOffer from '@/features/assets/vanilla/store/special-offer.png?w=30;60;90&as=srcset&imagetools'
import singleSC from '@/features/assets/vanilla/store/single-sc.png?w=100;200;300&as=srcset&imagetools'

import CoinGC_sm from '@/features/assets/vanilla/coin-gc_sm.png?w=100;200;300&as=srcset&imagetools'
import CoinGC_md from '@/features/assets/vanilla/coin-gc_md.png?w=100;200;300&as=srcset&imagetools'
import CoinGC_chest from '@/features/assets/vanilla/coin-gc_chest.png?w=100;200;300&as=srcset&imagetools'

import CoinSC_sm from '@/features/assets/vanilla/coin-sc_sm.png?w=100;200;300&as=srcset&imagetools'
import CoinSC_md from '@/features/assets/vanilla/coin-sc_md.png?w=100;200;300&as=srcset&imagetools'
import CoinSC_chest from '@/features/assets/vanilla/coin-sc_chest.png?w=100;200;300&as=srcset&imagetools'

import CoinGCSC_sm from '@/features/assets/vanilla/coin-gc-sc_sm.png?w=100;200;300&as=srcset&imagetools'
import CoinGCSC_md from '@/features/assets/vanilla/coin-gc-sc_md.png?w=100;200;300&as=srcset&imagetools'
import CoinGCSC_chest from '@/features/assets/vanilla/coin-gc-sc_chest.png?w=100;200;300&as=srcset&imagetools'

import Page_404 from '@/features/assets/vanilla/404.png?w=148;296;444&as=srcset&imagetools'
import Geoblock from '@/features/assets/vanilla/geoblock.png?w=148;296;444&as=srcset&imagetools'

import accountBank from '@/features/assets/vanilla/account-bank.png?w=36;72;108&as=srcset&imagetools'
import discussion from '@/features/assets/vanilla/discussion.png?w=36;72;108&as=srcset&imagetools'
import lock from '@/features/assets/vanilla/lock.png?w=36;72;108&as=srcset&imagetools'
import shield from '@/features/assets/vanilla/shield.png?w=36;72;108&as=srcset&imagetools'

import gift1 from '@/features/assets/vanilla/gifts/gift-1.png?w=100;200;300&as=srcset&imagetools'
import gift2 from '@/features/assets/vanilla/gifts/gift-2.png?w=100;200;300&as=srcset&imagetools'
import gift3 from '@/features/assets/vanilla/gifts/gift-3.png?w=100;200;300&as=srcset&imagetools'

import gcStack_md from '@/features/assets/vanilla/gc-stack_md.png?w=100;200;300&as=srcset&imagetools'

import smallBackground from '@/features/assets/vanilla/small-bg.png'

import bearVanillaBannerFull from '@/features/assets/vanilla/default-hero-banner/bear-vanilla.webp?w=960;1440&as=srcset&imagetools'
import eagleVanillaBannerFull from '@/features/assets/vanilla/default-hero-banner/eagle-vanilla.webp?w=960;1440&as=srcset&imagetools'
import casinoVanillaBannerFull from '@/features/assets/vanilla/default-hero-banner/casino-vanilla.webp?w=960;1440&as=srcset&imagetools'
import chipVanillaBannerFull from '@/features/assets/vanilla/default-hero-banner/chip-vanilla.webp?w=960;1440&as=srcset&imagetools'

import bearVanillaBannerThumb from '@/features/assets/vanilla/default-hero-banner/bear-vanilla-thumb.webp'
import eagleVanillaBannerThumb from '@/features/assets/vanilla/default-hero-banner/eagle-vanilla-thumb.webp'
import casinoVanillaBannerThumb from '@/features/assets/vanilla/default-hero-banner/casino-vanilla-thumb.webp'
import chipVanillaBannerThumb from '@/features/assets/vanilla/default-hero-banner/chip-vanilla-thumb.webp'

import entryRequest from '@/features/assets/vanilla/out-of-tokens/entry-request.png?w=40;80;120&as=srcset&imagetools'
import dailyBonus from '@/features/assets/vanilla/out-of-tokens/daily-bonus.png?w=40;80;120&as=srcset&imagetools'
import socialContest from '@/features/assets/vanilla/out-of-tokens/social-contest.png?w=40;80;120&as=srcset&imagetools'
import freeGift from '@/features/assets/vanilla/out-of-tokens/free-gift.png?w=96;192;288&as=srcset&imagetools'
import buyGc from '@/features/assets/vanilla/out-of-tokens/buy-gc.png?w=40;80;120&as=srcset&imagetools'

import spinningGoldCoins from '@/features/assets/vanilla/spinning_gold_coin.gif'
import spinningSweepsCoins from '@/features/assets/vanilla/spinning_sweeps_coin.gif'

import genericError from '@/features/assets/vanilla/generic-error.png?w=60;120;240&as=srcset&imagetools'

import accessControlsConfirmationTick from '@/features/assets/vanilla/tick.png?w=74;148;296&as=srcset&imagetools'

import questsOnboardingJoin from '@/features/assets/vanilla/quests-onboarding-join.webp'
import questsOnboardingPlay from '@/features/assets/vanilla/quests-onboarding-play.webp'
import questsOnboardingClaim from '@/features/assets/vanilla/quests-onboarding-claim.webp'

import bell from '@/features/assets/vanilla/bell.png?w=48;96;144&as=srcset&imagetools'

const ASSETS_BRAND_CONFIGS: AssetConfig = {
  animations: {
    loader: null,
    spinningCoins: {
      gc: spinningGoldCoins,
      sc: spinningSweepsCoins,
    },
  },
  accountBank: accountBank,
  discussion: discussion,
  gifts: {
    gift1: gift1,
    gift2: gift2,
    gift3: gift3,
  },
  lock: lock,
  bell: bell,
  shield: shield,
  logo: {
    mobile: logoMobile,
    desktop: logoDesktop,
  },
  store: {
    competition: competition,
    postal: postal,
    social: social,
    specialOffer: specialOffer,
    singleSC: singleSC,
  },
  coins: {
    gc: {
      sm: CoinGC_sm,
      md: CoinGC_md,
      chest: CoinGC_chest,
    },
    sc: {
      sm: CoinSC_sm,
      md: CoinSC_md,
      chest: CoinSC_chest,
    },
    gc_sc: {
      sm: CoinGCSC_sm,
      md: CoinGCSC_md,
      chest: CoinGCSC_chest,
    },
  },
  stacks: {
    gc: {
      md: gcStack_md,
    },
  },
  backgroundImages: {
    smallBackground: smallBackground,
  },
  page404: Page_404,
  geoblock: Geoblock,
  outOfTokens: {
    entryRequest: entryRequest,
    dailyBonus: dailyBonus,
    socialContest: socialContest,
    freeGift: freeGift,
    buyGc: buyGc,
  },
  heroBanner: {
    firstBannerFull: bearVanillaBannerFull,
    secondBannerFull: eagleVanillaBannerFull,
    thirdBannerFull: casinoVanillaBannerFull,
    fourthBannerFull: chipVanillaBannerFull,
    firstBannerThumb: bearVanillaBannerThumb,
    secondBannerThumb: eagleVanillaBannerThumb,
    thirdBannerThumb: casinoVanillaBannerThumb,
    fourthBannerThumb: chipVanillaBannerThumb,
  },
  genericError,
  accessControlsConfirmationTick,
  questsOnboardingAssets: {
    join: questsOnboardingJoin,
    play: questsOnboardingPlay,
    claim: questsOnboardingClaim,
  },
}

export default ASSETS_BRAND_CONFIGS
